"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cavaso-del-tomba": {
    "4a01242c": [{
      "hkey": "c96656f8",
      "slug": "caniezza",
      "name": "Caniezza",
      "primary": true,
      "skipSearch": false
    }],
    "capovilla": [{
      "hkey": "c96656f8",
      "slug": "caniezza",
      "name": "Caniezza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cavaso-del-tomba"
    }],
    "7f7994b6": [{
      "hkey": "33a08854",
      "slug": "bocca-di-serra-castelcies",
      "name": "Bocca di Serra-Castelcies",
      "primary": true,
      "skipSearch": false
    }],
    "castelcies": [{
      "hkey": "33a08854",
      "slug": "bocca-di-serra-castelcies",
      "name": "Bocca di Serra-Castelcies",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "53331527": [{
      "hkey": "c96656f8",
      "slug": "caniezza",
      "name": "Caniezza",
      "primary": true,
      "skipSearch": false
    }],
    "colmelli-caniezza": [{
      "hkey": "c96656f8",
      "slug": "caniezza",
      "name": "Caniezza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ede1a11e": [{
      "hkey": "c96656f8",
      "slug": "caniezza",
      "name": "Caniezza",
      "primary": true,
      "skipSearch": false
    }],
    "obledo": [{
      "hkey": "c96656f8",
      "slug": "caniezza",
      "name": "Caniezza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cavaso-del-tomba"
    }],
    "43349c35": [{
      "hkey": "c96656f8",
      "slug": "caniezza",
      "name": "Caniezza",
      "primary": true,
      "skipSearch": false
    }],
    "pieve": [{
      "hkey": "c96656f8",
      "slug": "caniezza",
      "name": "Caniezza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cavaso-del-tomba"
    }]
  }
};
exports["default"] = _default;